import { CardsGrid } from './organisms/grid.js';
import { CardsSlider } from './organisms/slider/slider.js';
import { jsx } from 'react/jsx-runtime';

function CardsComponent(props) {
  switch (props.options.display) {
    case "grid":
      return /*#__PURE__*/jsx(CardsGrid, {
        ...props
      });
    case "slider":
      return /*#__PURE__*/jsx(CardsSlider, {
        ...props
      });
  }
}

export { CardsComponent };
//# sourceMappingURL=component.cards.js.map
